import { Directive, HostListener, inject, Input } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import ru from './core/locale/ru.json'
import en from './core/locale/en.json'
import { UseLocales } from '@modules/lang-module/decorators/use-locales'
import { AlertService } from '@shared/services/alert.service'

@UseLocales({ ru, en })
@Directive({
	selector: '[clipboard]',
})
export class ClipboardDirective {
	@Input('clipboard') textToCopy: string | null | undefined = null

	private readonly _alertService: AlertService = inject<AlertService>(AlertService)
	private readonly _translateService: TranslateService = inject<TranslateService>(TranslateService)

	@HostListener('click')
	onClick(): void {
		if (!this.textToCopy) return
		navigator.clipboard.writeText(this.textToCopy).then((): void => {
			this._alertService.success(this._translateService.instant('clipBoard.copySuccess'))
		})
	}
}
